<template>
  <div id="homePage">
    <div class="homePage-box">
      <div id="banner-bg">
        <div class="homePage-header">
          <div class="logo" >
            <!-- <span class="icon-img_logo_142_26"></span> -->
          </div>
          <div class="right-menu">
            <a-button type="link" class="login-btn" @click="login(); burry('34')">登录</a-button>
            <a-button type="primary" class="register-btn" @click="register();burry('35')">注册</a-button>
          </div>
        </div>
        <div class="homePage-banner">
          <div class="banner-bg">
            <img src="../../assets/img/btn_banner_new.png" alt="">
            <img class="banner-btn wow fadeInUp" @click="register();burry('36')" src="../../assets/img/btn_banner.png" alt="">
          </div>
          <div class="banner-item" >
            <img id="gold_1" class="banner-widget" src="../../assets/img/gold_1.png" alt="">
            <img id="gold_2" class="banner-widget" src="../../assets/img/gold_2.png" alt="">
            <img id="gold_3" class="banner-widget" src="../../assets/img/gold_3.png" alt="">
            <img id="gold_4" class="banner-widget" src="../../assets/img/gold_4.png" alt="">
            <img id="role_1" class="banner-widget" src="../../assets/img/role_1.png" alt="">
            <img id="pancel_1" class="banner-widget" src="../../assets/img/pancel_1.png" alt="">
            <img id="diom_1" class="banner-widget" src="../../assets/img/diom_1.png" alt="">
            <img id="diom_2" class="banner-widget" src="../../assets/img/diom_2.png" alt="">
            <img id="cam_1" class="banner-widget" src="../../assets/img/cam_1.png" alt="">
          </div>

        </div>
      </div>

      <div class="homePage-content">
        <div class="content-block block-1" style="height:40px">
          <!-- <div class="title"> <span>合作模式</span>  </div>
          <div class="block-1-content">
            <div class="nav">
              <div class="nav-item " v-for="(item,index) in navList" :key="item.id" :class="{'active': activeNav === index}" @click="activeNav = index">
                {{ item.text }}
              </div>

            </div>
            <div class="content-image">
              <div class="content-image-item">
                <p class="info-text">零门槛入驻，拥有自由创作空间，上传一套作品即可获得长期分成</p>
                <img class="bg-img" src="" alt="">
              </div>

            </div>
          </div> -->
        </div>
        <div class="content-block block-2">
          <div class="bg-block-1 wow slideInLeft" data-wow-duration="0.5s"></div>
          <div class="title wow fadeInUp" > <span>平台优势</span> </div>

          <div class="platform-list wow fadeInUp">
            <div class="platform-item " >
              <div class="cover-icon">
                <img src="../../assets/img/icon_create_1.png" alt="">
              </div>
              <div class="name">自由创作</div>
              <div class="desc">创作方向自由，1步上传素材坐等审核上架。做自己喜欢的事获得收益。</div>
            </div>
            <div class="platform-item ">
              <div class="cover-icon">
                <img src="../../assets/img/icon_money_1.png" alt="">
              </div>
              <div class="name">永久分成</div>
              <div class="desc">永久售卖分成，每月定时提现拿收益，还有机会参与官方征稿，获得稿费。</div>
            </div>
            <div class="platform-item ">
              <div class="cover-icon">
                <img src="../../assets/img/icon_product_1.png" alt="">
              </div>
              <div class="name">作品传播</div>
              <div class="desc">短视频达人矩阵，千万级用户流量，助力素材营销传播。</div>
            </div>
            <div class="platform-item ">
              <div class="cover-icon">
                <img src="../../assets/img/icon_star_1.png" alt="">
              </div>
              <div class="name">明星画师</div>
              <div class="desc">业内知名二次元平台，周边+线下产品+广告联运，成为明星画师，打造头部影响力。</div>
            </div>
          </div>

          <div class="bg-block-2" ></div>
        </div>
        <div class="content-block block-3">
          <div class="title wow fadeInUp"> <span>合作案例</span> </div>
          <div class="case wow fadeInUp">
            <div class="case-wrap">

              <div class="case-content" v-for="(item,index) in caseList" :key="item.id" v-show="activeCaseNav == index">
                <div class="case-avatar">
                  <span class="avatar">
                    <img :src="item.avatar" alt="">
                  </span>
                  <span class="shop-name">{{ item.shopName }}</span>
                </div>
                <div class="case-desc">{{ item.desc }}</div>
                <div class="case-list">
                  <div class="case-list-item" v-for="(theme,i) in item.themeList" :key="i">
                    <img :src="theme.img" alt="">
                  </div>
                </div>
              </div>

            </div>
            <div class="case-nav">
              <div class="nav_bg " :style="{top: activeCaseNav * 112 + 'px' }"></div>
              <div class="case-nav-item" :class="{'active': activeCaseNav == index}" v-for="(item,index) in caseList" :key="item.id" @mouseover.self="activeCaseNav = index">
                <img :src="item.avatar" class="avatar" alt="">
              </div>
            </div>
          </div>

        </div>
        <div class="bg-block-3"></div>
        <div class="content-block block-4">
          <div class="title wow fadeInUp"><span>作品案例</span></div>
          <div class="swiper-box wow fadeInUp">
            <div class="big-slider">
              <swiper ref="bigSwiper" :options="bigOption" >
                <swiper-slide v-for="(item) in bigList" :key="item.id" >
                  <div class="big-item" >
                    <img :src="item.img" alt="">
                  </div>
                </swiper-slide>
              </swiper>
              <div class="big-swiper-button-prev" slot="button-prev" >
                <span ></span>
              </div>
              <div class="big-swiper-button-next" slot="button-next" >
                <span ></span>
              </div>
            </div>
            <div class="small-slider">
              <swiper ref="smallSwiper" :options="rankOption" >
                <swiper-slide v-for="(item) in bigList" :key="item.id" >
                  <div class="small-item">
                    <img :src="item.img" alt="">
                  </div>
                </swiper-slide>
              </swiper>
              <div class="small-swiper-button-prev" slot="button-prev" >
                <span class="icon-icon_previous"></span>
              </div>
              <div class="small-swiper-button-next" slot="button-next" >
                <span class="icon-icon_next"></span>
              </div>
            </div>
          </div>
        </div>
        <div class="content-block block-5">
          <div class="title wow pulse">成为M Art画师，用创意创造价值</div>
          <div class="register wow fadeIn" @click="register();burry('37')">
            立即注册
          </div>
        </div>
      </div>
    </div>
    <bottom style="min-width:1600px"></bottom>
  </div>
</template>

<script >
import { WOW } from 'wowjs'
import bottom from '@/components/Layout/Bottom'
export default {
  name: 'HomePage',
  data () {
    return {
      activeNav: 0,
      activeCaseNav: 0,
      activeSwiperIndex: 0,
      bigOption: {
        watchSlidesProgress: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        slideToClickedSlide: true,
        loop: true,
        loopedSlides: 7,
        navigation: {
          nextEl: '.big-swiper-button-next',
          prevEl: '.big-swiper-button-prev'
        },
        on: {
          progress: function (progress) {
            for (let i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i)
              var slideProgress = this.slides[i].progress
              // let modify = 1
              // if (Math.abs(slideProgress) > 1) {
              //   modify = (Math.abs(slideProgress) - 1) * 0.3 + 1
              // }
              const translate = slideProgress * 260 + 'px'
              const scale = 1 - Math.abs(slideProgress) / 4
              const zIndex = 999 - Math.abs(Math.round(10 * slideProgress))
              slide.transform('translateX(' + translate + ') scale(' + scale + ')')
              slide.css('zIndex', zIndex)
              slide.css('opacity', 1)
              if (Math.abs(slideProgress) > 3) {
                slide.css('opacity', 0)
              }
            }
          },
          // slideChange: function () {
          //   that.activeSwiperIndex = this.activeIndex
          //   // that.$refs.smallSwiper.swiper.slideTo(this.activeIndex, 0)
          // },
          setTransition: function (transition) {
            for (var i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i)
              slide.transition(transition)
            }
          }
        }
      },
      bigList: [{ id: 1, img: require('../../assets/img/home_case_1.jpg') }, { id: 2, img: require('../../assets/img/home_case_2.jpg') }, { id: 3, img: require('../../assets/img/home_case_3.jpg') }, { id: 4, img: require('../../assets/img/home_case_4.jpg') }, { id: 5, img: require('../../assets/img/home_case_5.jpg') }],
      caseList: [
        { id: 1, avatar: require('../../assets/img/home_shop_avatar.jpg'), shopName: '蚂蚁店铺', desc: '蚂蚁店铺，资深画师，为M Art提供了累计100+个优秀作品。艺术来源于生活，画画就是把想象付诸于现实，感谢M Art的包容性，让我们的作品受到更多人关注和使用。', themeList: [{ img: require('../../assets/img/home_shop_1.png') }, { img: require('../../assets/img/home_shop_2.png') }, { img: require('../../assets/img/home_shop_3.png') }] },
        { id: 2, avatar: require('../../assets/img/home_summer_avatar.jpg'), shopName: '夏天百货', desc: '职业画师。职场小萌新也可以做的兼职，利用业余时间不仅可以提高我自己的专业设计技能，每一个月还有一笔客观的收入。', themeList: [{ img: require('../../assets/img/home_summer_1.png') }, { img: require('../../assets/img/home_summer_2.png') }, { img: require('../../assets/img/home_summer_3.png') }] },
        { id: 3, avatar: require('../../assets/img/home_iomic_avatar.png'), shopName: '知谦漫画', desc: '资深画师，从业3年，累计创作上百张优质M Art素材。大单子并不是时时都有，只需抽空设计素材上传就可以，重点是不需要去找客户，所以很方便。', themeList: [{ img: require('../../assets/img/home_iomic_1.png') }, { img: require('../../assets/img/home_iomic_2.png') }, { img: require('../../assets/img/home_iomic_3.png') }] }
      ],
      rankOption: {
        slidesPerView: 'auto',
        slideToClickedSlide: true,
        loop: true,
        loopedSlides: 7,
        centeredSlides: true,
        navigation: {
          nextEl: '.small-swiper-button-next',
          prevEl: '.small-swiper-button-prev'
        },
        on: {
          // slideChange: function () {
          //   that.activeSwiperIndex = this.activeIndex
          //   // that.$refs.smallSwiper.swiper.slideTo(this.activeIndex, 0)
          // }
        }
      }
    }
  },
  components: { bottom },
  computed: {},
  created () {},
  mounted () {
    this.burry('33')
    document.querySelector('#banner-bg').addEventListener('mousemove', function (e) {
      const horizontal = e.clientX / parseInt(getComputedStyle(document.querySelector('#banner-bg')).width, 10)
      const vertical = e.clientY / parseInt(getComputedStyle(document.querySelector('#banner-bg')).height, 10)
      // Array.from(document.querySelectorAll('#banner-bg img')).forEach(item => {
      //   item.style.transition = ''
      // })
      document.querySelector('#gold_1').style.transform = calculateTransform(horizontal, vertical, 5)
      document.querySelector('#gold_2').style.transform = calculateTransform(horizontal, vertical, 5)
      document.querySelector('#gold_3').style.transform = calculateTransform(horizontal, vertical, -5)
      document.querySelector('#gold_4').style.transform = calculateTransform(horizontal, vertical, -5)
      document.querySelector('#role_1').style.transform = calculateTransform(horizontal, vertical, 15)

      document.querySelector('#pancel_1').style.transform = calculateTransform(horizontal, vertical, 10)
      document.querySelector('#diom_1').style.transform = calculateTransform(horizontal, vertical, 10)
      document.querySelector('#diom_2').style.transform = calculateTransform(horizontal, vertical, 10)
      document.querySelector('#cam_1').style.transform = calculateTransform(horizontal, vertical, -10)
    })
    // document.querySelector('#banner-bg').addEventListener('mouseleave', function (e) {
    //   console.log()
    //   // Array.from(document.querySelectorAll('#banner-bg img')).forEach(item => {
    //   //   item.style.transition = '0.6s all ease'
    //   // })
    //   document.querySelector('#gold_1').style.transform = `translate(0px, 0px)`
    //   document.querySelector('#gold_2').style.transform = `translate(0px, 0px)`
    //   document.querySelector('#gold_3').style.transform = `translate(0px, 0px)`
    //   document.querySelector('#gold_4').style.transform = `translate(0px, 0px)`
    //   document.querySelector('#role_1').style.transform = `translate(0px, 0px)`

    //   document.querySelector('#pancel_1').style.transform = `translate(0px, 0px)`
    //   document.querySelector('#diom_1').style.transform = `translate(0px, 0px)`
    //   document.querySelector('#diom_2').style.transform = `translate(0px, 0px)`
    //   document.querySelector('#cam_1').style.transform = `translate(0px, 0px)`
    // })
    function calculateTransform (horizontal, vertical, offset) {
      return `translate(${horizontal * offset / 0.5}px, ${vertical * offset / 0.5}px)`
    }
    this.$nextTick(() => {
      const swiperTop = this.$refs.bigSwiper.swiper
      const swiperThumbs = this.$refs.smallSwiper.swiper
      swiperTop.controller.control = swiperThumbs
      swiperThumbs.controller.control = swiperTop
    })
    new WOW().init()
  },
  methods: {
    login () {
      this.$router.push({
        path: '/user/login'
      })
    },
    register () {
      this.$router.push({
        path: '/user/register'
      })
    },
    bigSliderMove (item, index) {
      console.log(index)
      this.Index = index
      this.$nextTick(() => {
        this.$refs.bigSwiper.swiper.slideTo(index)
      })
    }
  },
  watch: {
    // activeSwiperIndex (val) {
    //   console.log(val)
    //   this.$refs.bigSwiper.swiper.slideTo(val)
    //   this.$refs.smallSwiper.swiper.slideTo(val, 0)
    // }
  }
}
</script>

<style lang='less' scoped>
#homePage{
  width: 100vw;
  overflow: auto;
  .homePage-box{
    /*min-width: 1600px;*/
    .homePage-header {
      height: 64px;
      line-height: 64px;
      display: flex;
      justify-content: space-between;
      background-color: #1E2230;
      padding: 0 24px 0 56px;
      .logo {
        width: 104px;
        height: 64px;
        background: url(../../assets/img/mart.png) left center / 100% no-repeat;
        span {
          font-size: 142px;
          color: @primary-color;
        }
      }
      .right-menu {
        color: #FFFFFF;
        .login-btn{
          font-size: 16px;
          color: #CCCCCC;
          margin-right: 17px;
        }
        .register-btn{
          font-size: 16px;
          border-radius: 16px;
          padding: 0 20px;
        }
      }
    }
    .homePage-banner{
      height: 800px;
      background-color: #FAFAFA;
      position: relative;
      overflow: hidden;
      .banner-bg {
        .banner-btn {
          display: block;
          position: absolute;
          top: 587px;
          left: 376px;
          cursor: pointer;
          z-index: 9999;
        }
      }
      .banner-item{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50% , -50%);
        width: 100%;
        height: 100%;
        width: 800px;

        #gold_1{
          position: absolute;
          width: 74px;
          height: 76px;
          top: 38px;
          right: 564px;
        }
        #gold_2{
          position: absolute;
          width: 43px;
          height: 45px;
          top: 25px;
          right: 54px;
        }
        #gold_3{
          position: absolute;
          width: 43px;
          height: 45px;
          top: 330px;
          right:196px;
        }
        #gold_4{
          position: absolute;
          width: 79px;
          height: 80px;
          top: 50px;
          right: -403px;
        }
        #role_1{
          position: absolute;
          top: 0px;
          right: -286px;
        }
        #cam_1{
          position: absolute;
          top: 147px;
          right: 177px;
        }
        #diom_1{
          position: absolute;
          top: -6px;
          right: 271px;
        }
        #diom_2{
          position: absolute;
          top: 375px;
          right: -88px;
        }
        #pancel_1{
          position: absolute;
          top: 97px;
          right: 36px;
        }
      }
    }
    .homePage-content{

      .content-block{
        .title {
          color: #333333;
          font-size: 36px;
          width: 186px;
          height: 50px;
          text-align: center;
          margin:0 auto 55px;
          background-image: url('../../assets/img/img_title_bg_186_50.png');
          background-repeat: no-repeat;
          background-size: contain;
          display: flex;
          justify-content: center;
          align-items: center;
          span {
            display: block;
            line-height: 1;
            position: relative;
            top: -5px;
          }
        }
        &.block-1 {
          background-color: #FAFAFA;
          padding: 63px 0 58px 0;
          .block-1-content{
            width: 1200px;
            margin: 0 auto;
            .nav {
              display: flex;
              margin-bottom: 40px;
              .nav-item {
                width: 150px;
                height: 52px;
                line-height: 52px;
                text-align: center;
                margin-right: 30px;
                background-image: url('../../assets/img/tab_mode_bg_n.png');
                background-size: 100% 100%;
                background-repeat: no-repeat;
                font-size: 20px;
                color: #999999;
                cursor: pointer;
                &:hover {
                  background-image: url('../../assets/img/tab_mode_bg_hover.png');
                  color: #FF7401;
                }
                &.active{
                  background-image: url('../../assets/img/tab_mode_bg_s.png');
                  color: #FFFFFF;
                }
              }
            }
            .content-image {
              border-radius: 16px;
              width: 1200px;
              height: 600px;
              overflow: hidden;

              .content-image-item {
                position: relative;
                width: 100%;
                height: 100%;
                &::after{
                  content: '';
                  display: block;
                  width: 100%;
                  height: 100%;
                  position: absolute;
                  top: 0;
                  left: 0;
                  background-color: rgba(0, 0, 0, 0.5);
                  z-index: 1;
                }
                .info-text {
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  font-size: 24px;
                  color: #FFFFFF;
                  transform: translate(-50%,-50%);
                  z-index: 2;
                  white-space:nowrap
                }
                .bg-img {
                  width: 100%;
                  height: auto;
                  display: block;
                }
              }

            }
          }
        }
        &.block-2 {
          background-color: #F0F2F5;
          .platform-list {
            width: 1200px;
            padding: 0 0 30px;
            display: flex;
            justify-content: space-between;
            margin: 0 auto;
            .platform-item{
              width: 218px;
              .cover-icon {
                height: 218px;
                margin-bottom: 35px;
              }
              .name {
                color: #333333;
                font-size: 24px;
                text-align: center;
                margin-bottom: 20px;
              }
              .desc {
                font-size: 16px;
                color: #666666;
                line-height: 30px;
              }
            }
          }
          .bg-block-1 {
            height: 130px;
            background-image: url('../../assets/img/img_bg_wave_1.png');
            background-repeat: repeat-x;
            margin-bottom: 20px;
          }
          .bg-block-2 {
            height: 130px;
            background-image: url('../../assets/img/img_bg_wave_2.png');
            background-repeat: repeat-x;
          }
        }
        &.block-3 {
          background-color: #FAFAFA;
          padding: 47px 0 33px;
          .case {
            width: 1200px;
            height: 528px;
            margin: 0 auto;
            position: relative;
            .case-wrap{
              height: 528px;
              overflow: hidden;
            }
            .case-content{
              width: 1060px;
              height: 528px;
              box-sizing: border-box;
              padding: 28px 32px 35px;
              background-color: #ffffff;
              box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.06);
              border-radius: 16px;
              .case-avatar  {
                display: flex;
                align-items: center;
                margin-bottom: 22px;
                .avatar {
                  display: block;
                  width: 60px;
                  height: 60px;
                  border-radius: 50%;
                  box-sizing: border-box;
                  border: 1px solid #FF7401;
                  z-index: 10;
                  overflow: hidden;
                  img {
                    width: 100%;
                    height: auto;
                  }
                }
                .shop-name {
                  display: block;
                  font-size: 16px;
                  background-color: #FF7401;
                  color: #ffffff;
                  padding: 9px 20px 8px 20px;
                  border-radius: 0px 16px 16px 0px;
                  position: relative;
                  line-height: 1;
                  left: -8px;
                  z-index: 1;
                }
              }
              .case-desc{
                color: #333333;
                font-size: 16px;
                line-height: 24px;
                margin-bottom: 32px;
              }
              .case-list {
                display: flex;
                justify-content: space-between;
                .case-list-item {
                  width: 310px;
                  height: 310px;
                  border-radius: 8px;
                  overflow: hidden;
                  background-color: rgba(0, 0, 0, 0.5);
                  &:hover {
                    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.15);
                    img{
                      transform: scale(1.1);
                      cursor: pointer;
                    }
                  }
                  img {
                    display: block;
                    width: 100%;
                    height: auto;
                     transition: all 0.3s ease-in;
                  }
                }
              }
            }
            .case-nav {
              position: absolute;
              right: 0;
              top: -6px;
              display: flex;
              flex-direction: column;
              .nav_bg {
                transition: 0.1s all ease-in-out;
                position: absolute;
                width: 162px;
                height: 112px;
                background-image: url('../../assets/img/img_case_selected_bg.png');
                background-size: 100% 100%;
                background-repeat: no-repeat;
                z-index: 0;
                animation: fadeIn ;
              }
              .case-nav-item{
                width: 162px;
                height: 112px;
                display: flex;
                justify-content: center;
                align-items: center;
                z-index: 10;
                cursor: pointer;
                &.active {
                  .avatar {
                    border: 2px solid #FF7401;
                  }
                }
                &:hover {
                  .avatar {
                    border: 2px solid #FF7401;
                  }
                }
                .avatar {
                  width: 80px;
                  height: 80px;
                  box-sizing: border-box;
                  border: 2px solid #e5e5e5;
                  border-radius: 50%;
                  pointer-events: none;
                  position: relative;
                  left: 10px;
                  cursor: pointer;

                }
                // &.active {
                //   background-image: url('../../assets/img/img_case_selected_bg.png');
                //   background-size: 100% 100%;
                //   background-repeat: no-repeat;
                // }
              }
            }
          }
        }
        &.block-4 {
          background-color: #F0F2F5;
          padding: 47px 0 82px;
          .swiper-box {
            .big-slider {
              height: 400px;
              margin-bottom: 40px;
              position: relative;
               .swiper-slide {
                 width: 700px;
                 height: 394px;
                 .big-item {
                    width: 700px;
                    height: 394px;
                    overflow: hidden;
                    cursor: pointer;
                    img {
                      display: block;
                      width: 100%;
                      height: auto;
                      cursor: pointer;
                    }
                 }
               }
               .big-swiper-button-prev {
                width: 220px;
                height: 198px;
                background: linear-gradient(to right, rgba(255, 255, 255, 1), transparent);
                border-radius: 0px 8px 8px 0px;
                display: flex;
                justify-content: center;
                align-items: center;
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-51.5%);
                z-index: 10;
                margin: 0;
                 cursor: pointer;
                &:focus {
                      outline: none;
                }
                &.swiper-button-disabled {
                  opacity: 1;
                  span {
                    background-image: url('../../assets/img/icon_switch_next_72_d.png');
                  }
                }
                &:hover {
                  span {
                    display: block;
                  }
                }
                span {
                  display: none;
                  width: 72px;
                  height: 72px;
                  background-image: url('../../assets/img/icon_switch_previous_72_n.png');
                  background-size: 100% 100%;
                  &:hover {
                    background-image: url('../../assets/img/icon_switch_previous_72_hover.png');
                    background-position: -1px -1px;
                  }

                }
              }
              .big-swiper-button-next {
                width: 220px;
                height: 198px;
                display: flex;
                justify-content: center;
                align-items: center;
                background: linear-gradient(to left, rgba(255, 255, 255, 1), transparent);
                border-radius: 8px 0px 0px 8px;
                position: absolute;
                right: 0;
                top: 50%;
                transform: translateY(-51.2%);
                 cursor: pointer;
                z-index: 10;
                margin: 0;
                &.swiper-button-disabled {
                  opacity: 1;

                  span {
                    background-image: url('../../assets/img/icon_switch_next_72_d.png');
                  }
                }
                &:focus {
                      outline: none;
                }
                &:hover {
                  span {
                    display: block;
                  }
                }
                span {
                  display: none;
                  width: 72px;
                  height: 72px;
                  background-image: url('../../assets/img/icon_switch_next_72_n.png');
                  background-size: 100% 100%;
                  &:hover {
                    background-image: url('../../assets/img/icon_switch_next_72_hover.png');
                    background-position: -1px -1px;
                  }

                }
              }
            }
            .small-slider {
              width: 700px;
              height: 80px;
              margin:  0 auto ;
              position: relative;
              &:hover {
                .small-swiper-button-prev {
                   display: flex;
                }
                .small-swiper-button-next {
                   display: flex;
                }
              }
              .swiper-slide {
                width: 80px;
                margin-right: 16px;
                &.swiper-slide-active {
                  .small-item {
                    border: 1px solid #FF7401;
                  }
                }
                .small-item {
                  width: 80px;
                  height: 80px;
                  border-radius: 4px;
                  overflow: hidden;
                  box-sizing: border-box;
                  border: 1px solid transparent;
                  &:hover {
                    border: 1px solid #FF7401;
                  }
                  cursor: pointer;

                  img {
                    display: block;
                    width: auto;
                    height: 100%;
                  }
                }
              }
              .small-swiper-button-prev {
                display: none;
                width: 40px;
                height: 60px;
                background-color: rgba(0, 0, 0, 0.6);
                border-radius: 0px 8px 8px 0px;

                justify-content: center;
                align-items: center;
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
                background-image: none;
                z-index: 10;
                margin: 0;
                 cursor: pointer;
                &:focus {
                      outline: none;
                }
                &.swiper-button-disabled {
                  opacity: 1;
                  span {
                    color: rgba(153, 153, 153, 1);
                  }
                }
                span {
                  font-size: 28px;
                  color: #ffffff;
                  &:hover {
                    color: rgba(255, 116, 1, 1);
                  }

                }
              }
              .small-swiper-button-next {
                display: none;
                width: 40px;
                height: 60px;

                justify-content: center;
                align-items: center;
                background-color: rgba(0, 0, 0, 0.6);
                border-radius: 8px 0px 0px 8px;
                position: absolute;
                right: 0;
                top: 50%;
                transform: translateY(-50%);
                background-image: none;
                z-index: 10;
                margin: 0;
                cursor: pointer;
                &.swiper-button-disabled {
                  opacity: 1;

                  span {
                    color: rgba(153, 153, 153, 1);
                  }
                }
                &:focus {
                      outline: none;
                }
                span {
                  font-size: 28px;
                  color: #ffffff;
                  &:hover {
                    color: rgba(255, 116, 1, 1);
                  }

                }
              }
            }
          }
        }
        &.block-5 {
          .title {
            width: 570px;
            margin:  120px  auto 60px ;
            background-image: none;
            position: relative;
            &::after {
              content: '';
              display: block;
              width: 54px;
              height: 95px;
              background-image: url('../../assets/img/img_login_left_bg_50_80.png');
              background-size: 100% 100%;
              background-repeat: no-repeat;
              position: absolute;
              left: -25px;
              top: -20px;
            }
            &::before {
              content: '';
              display: block;
              width: 54px;
              height: 95px;
              background-image: url('../../assets/img/img_login_right_bg_50_80.png');
              background-size: 100% 100%;
              background-repeat: no-repeat;
              position: absolute;
              right: -22px;
              top: -18px;
            }
          }
          .register {
            width: 240px;
            height: 60px;
            border-radius: 30px;
            background-color: #FF7401;
            margin: 0 auto;
            line-height: 60px;
            color: #ffffff;
            text-align: center;
            font-size: 24px;
            margin-bottom: 110px;
            cursor: pointer;
          }
        }
      }
      .bg-block-3 {
          height: 130px;
          background-image: url('../../assets/img/img_bg_wave_3.png');
          background-repeat: repeat-x;
        }
    }

  }
}
</style>
